// https://www.kunkalabs.com/mixitup/docs/get-started/
import mixitup from 'mixitup';

$(document).ready(function () {
    var initialFilter = 'all';
    var hash = window.location.hash.replace(/^#/g, '');
    if (hash) {
        initialFilter = '.id-' + hash;
        $(initialFilter).find('.accordion--slide').addClass('acc--show').show();
        $(initialFilter).find('.acc--title').removeClass('down').addClass('up');
        $('html, body').animate({
            scrollTop: $(initialFilter).offset().top
        }, 500);
        // var firstletter = $(initialFilter).attr('data-name').charAt(0);
        // $('.mixitup-control[data-toggle="'+firstletter+'"]').addClass('mixitup-active');
    }

    if ($('.mixit--filter').length) {
        var mixer = mixitup(".mixit--filter", {
            animation: {
                animateResizeTargets: true,
                duration: 550,
                nudge: true,
                reverseOut: false,
                effects: "fade scale(0.01) translateZ(-100px)"
            },
            // load: {
                // filter: initialFilter
            // }
        });


        $('.mixitup-control').each(function () {
            $(this).on('click', function () {
                if ($(this).hasClass('mixitup-active')) {
                    $(this).removeClass('mixitup-active');
                    mixer.filter('all');
                } else {
                    $('.mixitup-active').removeClass('mixitup-active');

                    $(this).addClass('mixitup-active');
                    var searchValue = $(this).attr('data-toggle');
                    mixer.filter('[data-name^="' + searchValue + '"]');


                }
            });

        })
    }
});

